import { shallowReactive } from "vue";
import mitt from '/@/utils/mitt';

export interface ViewMenuData extends MenuSaveConfigs{
    selectedMenu: {
        viewConfig: MenuSaveConfigs,
        [k: string]: any,
    },
    isOpenMenu: boolean,
    restoreConfig?: Recordable, // 融合搜索过滤项的保存配置，用于回显
    viewCustomCountMax?: number, // 视图数量
    viewCustomCount?: number, // 视图最大数量
}

export interface MenuSaveConfigs {
    filterConfig?: Recordable,
    searchConfig?: string,
    columnConfig?: Recordable,
    orderConfig?: Recordable,
}

export function generateMenuState(filterType = ''): ViewMenuData {
    // 因为只考虑外层数据的变动，所以用shallowReactive
    return shallowReactive({
        filterType,
        // 左侧视图的数据，数据结构与后台返回类型相同
        selectedMenu: {
            viewConfig: {
                filterConfig: [],
                searchConfig: '',
                columnConfig: {},
                orderConfig: {},
            }
        },
        // 是否打开视图
        isOpenMenu: true,
        // 融合搜索过滤项的配置项，用于下发查询的数据类型
        filterConfig: {
            superQueryMatchType: 'and',
            superQueryParams: encodeURI(JSON.stringify([])),
        },
        // 融合搜索的输入框的值
        searchConfig: '',
        orderConfig: null,
        columnConfig: null,
        viewCustomCountMax: 10,
        viewCustomCount: 0,
    })
}

let viewMenuEventBus;
generateEventBus()

function generateEventBus() {
    if (!viewMenuEventBus) {
        viewMenuEventBus = mitt();
    }
}

enum ViewMenuEventType {
    INIT_FUSION_FILTER_VALUE = 'INIT_FUSION_FILTER_VALUE',
    OPEN_MENU_CHANGE = 'OPEN_MENU_CHANGE',
    MENU_VIEW_UPDATE = 'MENU_VIEW_UPDATE',
}

export function emitDoneInitFusionFilterValue() {
    viewMenuEventBus.emit(ViewMenuEventType.INIT_FUSION_FILTER_VALUE);
}

export function onDoneInitFusionFilterValue(handler: (value: any) => void) {
    viewMenuEventBus.on(ViewMenuEventType.INIT_FUSION_FILTER_VALUE, handler);
}

export function emitOpenMenuChange(value: boolean) {
    viewMenuEventBus.emit(ViewMenuEventType.OPEN_MENU_CHANGE, value);
}

export function onOpenMenuChange(handler: (value: boolean) => void) {
    viewMenuEventBus.on(ViewMenuEventType.OPEN_MENU_CHANGE, handler);
}

export function emitMenuViewUpdateChange(value) {
    viewMenuEventBus.emit(ViewMenuEventType.MENU_VIEW_UPDATE, value);
}

export function onMenuViewUpdateChange(handler: (value) => void) {
    viewMenuEventBus.on(ViewMenuEventType.MENU_VIEW_UPDATE, handler);
}

export function clearViewMenuEventBus() {
    viewMenuEventBus.clear();
}
